var SwearingFactory = require('../../../../../factory/swearing');

module.exports = function (getRestrictions, value) {
  var restrictions = getRestrictions('swearing');

  restrictions = Array.isArray(restrictions) ? restrictions : [restrictions];

  if (restrictions.length) {
    for (const i in restrictions[0]) {
      const locale = restrictions[i]?.filter || i;
      if (SwearingFactory.matchSwearing(locale, value)) {
        throw {
          message: 'swearing',
          params: _.extend({ value: value }, restrictions[i])
        };
      }
    }
  }

  return value;
};
